import React from 'react'
import GetInTouch from './GetInTouch'
import GetInTouchForm from './GetInTouchForm' 
import OurLocation from './OurLocation'  


function ContactComponent() {
  return (
    <div>
        <GetInTouch/>
        <GetInTouchForm/>
        <OurLocation/>
    </div>
  )
}

export default ContactComponent